export const NOTICE_CATEGORIES = [
  { value: 'announcement', label: 'Announcement', color: '#1e40af' },
  { value: 'dashboard',    label: 'Dashboard',    color: '#d97706' },
  { value: 'donation',     label: 'Donation',     color: '#7c3aed' },
  { value: 'event',        label: 'Event',        color: '#059669' },
  { value: 'maintenance',  label: 'Maintenance',  color: '#dc2626' },
  { value: 'other',        label: 'Other',        color: '#6b7280' },
  { value: 'urgent',       label: 'Urgent',       color: '#ea580c' },
];

export const EMPTY_NOTICE = {
  title: '',
  content: '',
  category: 'announcement',
  expiryDate: '',
};
